export default "__VITE_ASSET__515cff87__"